import { useIntl } from "react-intl";
function ErrorMessage({ error }) {
  const intl = useIntl();
  if (!error) return null;

  // Strings pass through as-is (server-redirect ?error=… text is untranslated
  // until the backend sends codes); descriptor objects resolve their id
  // against the locale bundle, falling back to the inline defaultMessage.
  let message = error;

  if (typeof error === "object") {
    message = error.id
      ? intl.formatMessage({
          id: error.id,
          defaultMessage: error.defaultMessage,
        })
      : error.defaultMessage ||
        error.message ||
        intl.formatMessage({
          id: "auth.errorGeneric",
          defaultMessage: "An error occurred",
        });
  }

  return (
    <div className="text-primary-red relative my-[5px] mb-[15px] text-sm">
      {message}
    </div>
  );
}

export default ErrorMessage;
